var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c("CorpId"),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-3",
                attrs: {
                  label: _vm.$t.__("developerPage.Widgets.add_widget"),
                  type: "primary"
                },
                on: { click: _vm.createWidget }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.widgets.length
            ? _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.widgets,
                    defaultSort: { prop: "name", order: "ascending" },
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t.__("common.labels.name"),
                      width: "200",
                      sortable: "",
                      showOverflowTooltip: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t.__("common.labels.address") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "primary-50",
                                  attrs: {
                                    href: scope.row.website,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.website))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      821042952
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__("developerPage.Widgets.code_to_insert")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  readonly: true
                                },
                                model: {
                                  value: scope.row.formatted_hash,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "formatted_hash", $$v)
                                  },
                                  expression: "scope.row.formatted_hash"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4070006999
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: _vm.$t.__("common.labels.actions"),
                      width: "104"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex-row" },
                                [
                                  _c("CompassIconButton", {
                                    attrs: {
                                      icon: "settings",
                                      type: "tertiary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editWidget(scope.row.id)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("CompassIconButton", {
                                    staticClass: "ml-2",
                                    attrs: { icon: "bin", type: "tertiary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteWidget(scope.row.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3483353068
                    )
                  })
                ],
                1
              )
            : _c("div", { staticClass: "placeholder well" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$l10n.__("Vous ne disposez d'aucun formulaire actif")
                    ) +
                    "\n    "
                )
              ])
        ],
        1
      )
    : _c("preloader", { attrs: { background: false, display: true } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }